import { CircleCheck, Info, TriangleAlert, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cx } from '../lib/cx';
import { dismissToast, useToasts } from '../stores/toasts';

const ICONS = { info: Info, success: CircleCheck, error: TriangleAlert };

export function Toaster() {
  const toasts = useToasts((s) => s.toasts);
  const { t } = useTranslation();
  return (
    <div
      aria-live="polite"
      className="pointer-events-none fixed inset-x-0 top-3 z-[60] flex flex-col items-center gap-2 px-4"
    >
      {toasts.map((item) => {
        const Icon = ICONS[item.tone];
        return (
          <div
            key={item.id}
            role={item.tone === 'error' ? 'alert' : 'status'}
            className="animate-pop-in pointer-events-auto flex w-full max-w-md items-center gap-3 rounded-2xl border border-line bg-surface px-4 py-3 shadow-lg"
          >
            <Icon className={cx('size-5 shrink-0', item.tone === 'error' ? 'text-danger' : item.tone === 'success' ? 'text-herb' : 'text-brand')} />
            <p className="flex-1 text-sm">{item.message}</p>
            {item.action && (
              <button
                type="button"
                className="text-sm font-semibold text-brand hover:underline"
                onClick={() => {
                  item.action!.onClick();
                  dismissToast(item.id);
                }}
              >
                {item.action.label}
              </button>
            )}
            <button type="button" className="text-muted hover:text-ink" onClick={() => dismissToast(item.id)} aria-label={t('common.close')}>
              <X className="size-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
